var _path;
var _excluded = ["title", "titleId", "desc", "descId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
var SvgUpload = function SvgUpload(_ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    desc = _ref.desc,
    descId = _ref.descId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17,
    height: 16,
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    viewBox: "0 0 17 16",
    "aria-labelledby": titleId,
    "aria-describedby": descId
  }, props), desc ? /*#__PURE__*/React.createElement("desc", {
    id: descId
  }, desc) : null, title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 10v2.667A1.334 1.334 0 0 1 13.167 14H3.833A1.334 1.334 0 0 1 2.5 12.667V10M11.833 5.333 8.5 2 5.167 5.333M8.5 2v8"
  })));
};
export { SvgUpload as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTciIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNyAxNiIgZmlsbD0ibm9uZSIgc3Ryb2tlPSJjdXJyZW50Q29sb3IiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCIgc3Ryb2tlLWxpbmVqb2luPSJyb3VuZCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE0LjUgMTBWMTIuNjY2N0MxNC41IDEzLjAyMDMgMTQuMzU5NSAxMy4zNTk0IDE0LjEwOTUgMTMuNjA5NUMxMy44NTk0IDEzLjg1OTUgMTMuNTIwMyAxNCAxMy4xNjY3IDE0SDMuODMzMzNDMy40Nzk3MSAxNCAzLjE0MDU3IDEzLjg1OTUgMi44OTA1MiAxMy42MDk1QzIuNjQwNDggMTMuMzU5NCAyLjUgMTMuMDIwMyAyLjUgMTIuNjY2N1YxMCIgLz4KPHBhdGggZD0iTTExLjgzMzIgNS4zMzMzM0w4LjQ5OTg0IDJMNS4xNjY1IDUuMzMzMzMiIC8+CjxwYXRoIGQ9Ik04LjUgMlYxMCIgLz4KPC9zdmc+Cg==";